import * as braze from '@braze/web-sdk';
import { getDefaultConfig } from 'Utils/Store';

export const setBrazeUser = (profileId) => {
  const { nodeEnv } = getDefaultConfig();
  braze.changeUser(profileId);
  if (nodeEnv === 'development') {
    braze.requestImmediateDataFlush();
  }
};

// initialize the SDK
export const initBraze = (profileId) => {
  const { brazeApiKey, enableBrazeLogging, brazeContentCardsEnabled } = getDefaultConfig();
  braze.initialize(brazeApiKey, {
    baseUrl: 'sdk.iad-05.braze.com',
    // logging based on environment
    enableLogging: enableBrazeLogging,
    allowUserSuppliedJavascript: true,
  });

  // set user for braze session
  const brazeUser = profileId;
  if (brazeUser) {
    setBrazeUser(brazeUser);
  }

  // init braze content cards (banners)
  if (brazeContentCardsEnabled) {
    braze.subscribeToContentCardsUpdates();
    braze.requestContentCardsRefresh();
  }

  // init braze session
  braze.openSession();
};
